import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { ApplicationSettings } from './application-settings';


@Injectable()
export class ApplicationSettingsService {

  constructor(private httpClient: HttpClient) { }

  getApplicationSettings(): Promise<ApplicationSettings> {
    const url = `${environment.dotNetApiUrl}/ApplicationSettings`;
    return this.httpClient.get<ApplicationSettings>(url).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/application-settings/application-settings.service.ts